export const environment = {
  production: true,
  apiUrl: 'https://quizzz.ai/api'
};
